export const enum ActivityDetailsModalType {
  None = 'none',
  TicketsSelection = 'ticketsSelection',
}
